import React from 'react';
import PropTypes from 'prop-types';

import LinkWithImage from '../LinkWithImage';
import HeadingElement from '../HeadingElement';

import { StyledLinkGroup } from './styles';

const LinkGroupWithImages = ({ description, links, size, headingLevel }) => {
  if (links && links.length) {
    const linkElements = links.map((link) => (
      <li key={link.linkURL}>
        <LinkWithImage {...link} />
      </li>
    ));
    return (
      <StyledLinkGroup className="styledLinkGroup" size={size}>
        {description && (
          <HeadingElement headingLevel={headingLevel}>
            {description}
          </HeadingElement>
        )}
        <ul>{linkElements}</ul>
      </StyledLinkGroup>
    );
  }
  return null;
};

LinkGroupWithImages.propTypes = {
  description: PropTypes.string,
  links: PropTypes.array,
  size: PropTypes.string,
};

LinkGroupWithImages.defaultProps = {
  description: '',
  links: [],
  size: 'small',
};

export default LinkGroupWithImages;
